var exports = {
  "e": "prettifiedBlocksContainer__DIkI6s",
};

module.exports = exports;
